<template>
    <div v-if="!success" class="forgotten-password">
        <b-row class="justify-content-center">
            <b-col sm="10" class="text-center mb-50">
                <h1>Passwort vergessen?</h1>
                <h5>Kein Problem! Gib hier einfach deine E-Mail-Adresse ein und wir senden dir einen Code, mit dem du dein Passwort zurücksetzen kannst.</h5>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">

            <b-col sm="8" lg="5">
                <div class="mandatory-note text-center">
                    <p>* Pflichtfelder bitte ausfüllen</p>
                </div>
                <div class="mb-15 mt-30 pl-0 pr-0 floating-label">
                    <b-form-input class="mb-10" type="email" v-validate="'required|email'" name="email" placeholder="Deine E-Mail-Adresse*"
                                  v-model="email"/>
                    <label>E-Mail *</label>
                </div>

            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col sm="6" lg="4" class="text-center" >
                <button class="btn btn-primary"
                        type="button"
                        :disabled="!completed"
                @click="sendPasswordForgotten">Absenden</button>
            </b-col>
        </b-row>
    </div>
    <div v-else class="forgotten-password">
        <b-row class="justify-content-center">
            <b-col sm="10" class="text-center mb-50">
                <h1>Vielen Dank!</h1>
                <h5>Wir haben dir deinen Rücksetzcode per E-Mail zugesendet. Bitte überprüfe jetzt deinen Posteingang und folge den Anweisungen in der Mail, um dein Passwort zurückzusetzen.</h5>
            </b-col>
        </b-row>
    </div>



</template>
<script>

    import {apiForgotPassword} from "../utils/api";

    export default {
        name: 'passwordRequestCodeView',
        data: () => {
            return {
                email: '',
                success: false,
                error: false,
                message: ''

            }
        },
        methods: {
          sendPasswordForgotten(){
              apiForgotPassword({
                  "email": this.email
              })
                  .then(response => {
                      if (response.data.code === 0) {
                          this.success = true;
                      } else if (response.data.code === 1){
                          this.error = true;
                          this.message = response.data.message;
                          this.$toasted.error('E-Mail-Adresse unbekannt', {
                              duration: 3000,
                              position: 'bottom-right'
                          });
                      } else if (response.data.code === 2){
                          this.error = true;
                          this.message = response.data.message;
                          this.$toasted.error('Fehler beim Versenden der E-Mail', {
                              duration: 3000,
                              position: 'bottom-right'
                          });
                      } else if (response.data.code === 99){
                          this.error = true;
                          this.message = response.data.message;
                          this.$toasted.error('Pflichtfeld nicht ausgefüllt', {
                              duration: 3000,
                              position: 'bottom-right'
                          });
                      }

                  })
                  .catch(e => {
                      this.$store.commit('error', e);
                  });
          }
        },
        computed: {
            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
            },
        }
    };
</script>
